
<div>
  <div ref="yAxisSubtitles" class="y-axis-subtitles"></div>
  <highcharts :options="chart" :key="JSON.stringify(colors)"></highcharts>
</div>
